import { useEffect } from "react";
import {
  TonProofItemReplySuccess,
  useTonConnectUI,
  useTonWallet,
} from "@tonconnect/ui-react";
import { useMutation } from "@tanstack/react-query";
import { validateTonProof } from "../api/walletApi";
import { logger } from "@/shared/utils/logger";
import { TonProofPayload } from "../types/tonProofPayload";
import { useUserStore } from "@/modules/auth/store/user";

export const useTonWalletProof = () => {
  const wallet = useTonWallet();
  const { setActivated } = useUserStore();
  const [tonConnectUI] = useTonConnectUI();
  const { setWallet } = useUserStore();

  const mutation = useMutation({
    mutationFn: validateTonProof,
    onSuccess: () => {
      logger.info("✅ Wallet validated successfully");
      
      if (tonConnectUI.account?.address) {
        setWallet(tonConnectUI.account.address);
      }
    },
    onError: (error) => {
      logger.error("❌ Wallet validation failed:", error);
    },
  });

  useEffect(() => {
    logger.info("Wallet connected");
    logger.debug("wallet chain: " + wallet?.account.chain); // MAINNET = "-239", TESTNET = "-3"
    logger.debug("wallet address: " + wallet?.account.address);
    logger.debug("wallet tonProof: " + wallet?.connectItems?.tonProof);
    if (
      wallet &&
      wallet.account &&
      wallet.account.publicKey &&
      wallet.connectItems?.tonProof?.name === "ton_proof" &&
      "proof" in wallet.connectItems.tonProof
    ) {
      const tonProof = wallet.connectItems.tonProof as TonProofItemReplySuccess;

      logger.debug("wallet tonProof payload: " + tonProof.proof.payload);

      const payload: TonProofPayload = {
        address: wallet.account.address,
        network: wallet.account.chain,
        public_key: wallet.account.publicKey,
        proof: {
          ...tonProof.proof,
          state_init: wallet.account.walletStateInit,
        },
      };

      mutation.mutate(payload);

      setActivated(true);
    }
  }, [wallet]);

  return { isLoading: mutation.isPending };
};
